import { Option } from '@hcs/design-system';
import {
  CapabilityKeys,
  PortfolioEventsFields,
  PortfolioFormFieldConfig,
  PortfolioFormFields,
  PortfolioFormNotificationTypes,
  PortfolioPageParams,
  PortfolioParamsIds,
} from '@hcs/types';

import { MlsStatusLabel } from '../components/MlsStatusLabel';

export const PORTFOLIO_MONITOR_BILLING_CAPABILITY_KEY: CapabilityKeys =
  'portfolio-monitor-product-access';
export const PORTFOLIO_PAGE_PARAMS: PortfolioPageParams = {
  [PortfolioParamsIds.PortfolioId]: 'portfolioId',
};

export const PORTFOLIO_SETUP_FIELD_CONFIGS: {
  [field in PortfolioFormFields]: PortfolioFormFieldConfig;
} = {
  [PortfolioFormFields.Name]: {
    label: 'Portfolio Name',
    placeHolder: 'My Portfolio',
    field: PortfolioFormFields.Name,
  },
  [PortfolioFormFields.NotificationType]: {
    label: 'Notifications',
    field: PortfolioFormFields.NotificationType,
  },
  [PortfolioFormFields.MlsStatus]: {
    label: <MlsStatusLabel />,
    field: PortfolioFormFields.MlsStatus,
  },
  [PortfolioFormFields.LtvThresholds]: {
    label: 'LTV Thresholds',
    field: PortfolioFormFields.LtvThresholds,
  },
  [PortfolioFormFields.PropensityToListThresholds]: {
    label: 'Propensity to List Thresholds',
    field: PortfolioFormFields.PropensityToListThresholds,
  },
  [PortfolioFormFields.PropensityToRefiThresholds]: {
    label: 'Propensity to Refi Thresholds',
    field: PortfolioFormFields.PropensityToRefiThresholds,
  },
  [PortfolioFormFields.AvmThresholds]: {
    label: 'AVM Thresholds',
    field: PortfolioFormFields.AvmThresholds,
  },
  [PortfolioFormFields.Liens]: {
    label: 'Open Lien',
    field: PortfolioFormFields.Liens,
  },
  [PortfolioFormFields.Nod]: {
    label: 'Notice of Default',
    field: PortfolioFormFields.Nod,
  },
  [PortfolioFormFields.Emails]: {
    label: 'Email Delivery',
    placeHolder: 'username@email',
    field: PortfolioFormFields.Emails,
  },
  [PortfolioFormFields.WebhookUrl]: {
    label: 'Webhook Delivery',
    placeHolder: 'https://example.com',
    field: PortfolioFormFields.WebhookUrl,
  },
  [PortfolioFormFields.WebhookUsername]: {
    label: 'Username',
    placeHolder: 'username',
    field: PortfolioFormFields.WebhookUsername,
  },
  [PortfolioFormFields.WebhookPassword]: {
    label: 'Password',
    placeHolder: 'password',
    field: PortfolioFormFields.WebhookPassword,
  },
};

export const NOTIFICATION_TYPE_OPTIONS_INIT: Option<PortfolioFormNotificationTypes>[] =
  [
    {
      value: PortfolioFormNotificationTypes.Mls,
      label: 'Listing Status',
      detail: 'Get notified when Listing Status changes for your properties.',
    },
    {
      value: PortfolioFormNotificationTypes.Ltv,
      label: 'LTV',
      detail: 'Monitor LTV thresholds across your properties.',
    },
    {
      value: PortfolioFormNotificationTypes.Avm,
      label: 'AVM',
      detail: 'Track AVM changes for your properties.',
    },
    {
      value: PortfolioFormNotificationTypes.Lien,
      label: 'Open Lien',
      detail: 'Monitor new open liens placed on your properties.',
    },
    {
      value: PortfolioFormNotificationTypes.Nod,
      label: 'Notice of Default',
      detail:
        'Get notified when a Notice of Default is filed for one of your properties.',
    },
    {
      value: PortfolioFormNotificationTypes.PropensityToList,
      label: 'Propensity to List',
      detail: 'Get notified when your properties are likely to list.',
    },
    {
      value: PortfolioFormNotificationTypes.PropensityToRefi,
      label: 'Propensity to Refi',
      detail: 'Get notified when your properties are likely to refinance.',
    },
  ];

export const PORTFOLIO_EVENTS_FIELDS_LIST = Object.values(
  PortfolioEventsFields,
);

export const EVENT_FIELDS_TO_NOTIFICATION_TYPE: {
  [key in PortfolioEventsFields]: PortfolioFormNotificationTypes;
} = {
  [PortfolioEventsFields.Status]: PortfolioFormNotificationTypes.Mls,
  [PortfolioEventsFields.LtvThresholds]: PortfolioFormNotificationTypes.Ltv,
  [PortfolioEventsFields.PropensityToList]:
    PortfolioFormNotificationTypes.PropensityToList,
  [PortfolioEventsFields.PropensityToRefi]:
    PortfolioFormNotificationTypes.PropensityToRefi,
  [PortfolioEventsFields.Avm]: PortfolioFormNotificationTypes.Avm,
  [PortfolioEventsFields.Lien]: PortfolioFormNotificationTypes.Lien,
  [PortfolioEventsFields.Nod]: PortfolioFormNotificationTypes.Nod,
};

export const SEARCH_PARAM_ADD_PROPERTIES = 'add-properties';
